<template>
  <section class="overflow">
    <ProductCard
      v-for="p in products"
      v-bind="p"
      :key="p.id"
      :canAddToCart="true"
    />
  </section>
</template>

<script>
import { mapState } from "vuex";
import ProductCard from "./ProductCard";

export default {
  name: "CardDomainProduct",
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState("cart", ["cart"])
  },
  components: { ProductCard }
};
</script>

<style lang="scss" scoped>
  @import '../assets/variables';

  .overflow {
    background: $color-smoke;
    display: flex;
    flex-flow: row;
    align-items: stretch;
    gap: 10px;
    padding: 10px;
    margin-bottom: 1em;
    border-radius: $global-radius;
    overflow: auto;
  }

  .ProductCard {
    height: auto;
    padding: 10px;
    flex: 0 0 16em;
    font-size: 0.625em;
    border-radius: 3px;

    &::v-deep .ProductCard__picture { /* stylelint-disable-line selector-pseudo-element-no-unknown */
      max-height: 10em;
    }

    &::v-deep .ProductCard__logistic { /* stylelint-disable-line selector-pseudo-element-no-unknown */
      display: none;
    }

    @media (min-width: 960px) {
      flex-basis: 20em;
      font-size: 0.75em;
    }
  }
</style>
